(function initialiseSelleasyAccessibility() {
  if (window.uklSelleasyAccessibilityInitialised) return;
  window.uklSelleasyAccessibilityInitialised = true;

  class UklSelleasyAccessibility {
    constructor(scope) {
      this.scope = scope;
      this.buttonSelector = [
        '.lb-spc-details-btn',
        '.ppa-add-to-cart-btn',
        '.lb-upsell-tot-btn'
      ].join(',');
      this.selectSelector = '.lb-shared-variants-select, .lb-upsell-variants-select';
      this.enhance(scope);
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) this.enhance(node);
          });
        });
      });
      this.observer.observe(scope, { childList: true, subtree: true });
    }

    disconnect() {
      this.observer.disconnect();
    }

    enhance(root) {
      this.find(root, this.buttonSelector).forEach((control) => this.enhanceButton(control));
      this.find(root, this.selectSelector).forEach((select) => this.enhanceSelect(select));
    }

    find(root, selector) {
      const elements = [];
      if (root.matches?.(selector)) elements.push(root);
      if (root.querySelectorAll) elements.push(...root.querySelectorAll(selector));
      return elements;
    }

    enhanceButton(control) {
      if (control.dataset.uklAccessibilityEnhanced === 'true') return;
      const action = control.textContent.trim() || 'Add';
      const productTitle = this.getProductTitle(control);
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      if (!control.getAttribute('aria-label')) {
        control.setAttribute('aria-label', productTitle ? `${action} ${productTitle}` : action);
      }
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          control.click();
        } else if (event.key === ' ') {
          event.preventDefault();
        }
      });
      control.addEventListener('keyup', (event) => {
        if (event.key !== ' ') return;
        event.preventDefault();
        control.click();
      });
      control.dataset.uklAccessibilityEnhanced = 'true';
    }

    enhanceSelect(select) {
      if (select.getAttribute('aria-label') || select.getAttribute('aria-labelledby')) return;
      const productTitle = this.getProductTitle(select);
      const optionLabel = select.querySelector('option[disabled]')?.textContent.trim() || 'Options';
      select.setAttribute(
        'aria-label',
        productTitle ? `${optionLabel} for ${productTitle}` : optionLabel
      );
    }

    getProductTitle(element) {
      return element
        .closest('.lb-upsell-product-page-card, .lb-upsell-product-card')
        ?.querySelector('.lb-spc-details-name')
        ?.textContent
        ?.trim() || '';
    }
  }

  const instances = new WeakMap();

  function getScopes(root) {
    const scopes = [];
    if (root.matches?.('.cc-main-product')) scopes.push(root);
    if (root.querySelectorAll) scopes.push(...root.querySelectorAll('.cc-main-product'));
    return scopes;
  }

  function connect(root = document) {
    getScopes(root).forEach((scope) => {
      if (!instances.has(scope)) {
        instances.set(scope, new UklSelleasyAccessibility(scope));
      }
    });
  }

  function disconnect(root) {
    getScopes(root).forEach((scope) => {
      instances.get(scope)?.disconnect();
      instances.delete(scope);
    });
  }

  document.addEventListener('shopify:section:load', (event) => connect(event.target));
  document.addEventListener('shopify:section:unload', (event) => disconnect(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => connect(), { once: true });
  } else {
    connect();
  }
})();

(function initialisePdpAppAccessibility() {
  if (window.uklPdpAppAccessibilityInitialised) return;
  window.uklPdpAppAccessibilityInitialised = true;

  function find(root, selector) {
    const elements = [];
    if (root.matches?.(selector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(selector));
    return elements;
  }

  function enhanceAirReviews(root) {
    find(root, '#file-upload').forEach((input) => {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        input.setAttribute('aria-label', 'Upload review photos');
      }
    });

    find(root, '.AirReviews-Blocks--List').forEach((list) => {
      list.querySelectorAll(':scope > li[role="button"]').forEach((item) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ukl-air-review-filter';
        button.setAttribute('aria-label', item.getAttribute('aria-label') || 'Filter reviews');

        while (item.firstChild) button.appendChild(item.firstChild);
        item.removeAttribute('role');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-label');
        item.appendChild(button);
      });
    });
  }

  function connect() {
    const scope = document.querySelector('main');
    if (!scope) return;

    enhanceAirReviews(scope);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) enhanceAirReviews(node);
        });
      });
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
